import { Amplitude } from './amplitude.service'
import { EventLoggerInstanceName, GIA_API_KEYS } from '../constants'
import { getGIAAmplitudeOptions } from '../helpers/getGIAAmplitudeOptions'
import { eventLogger } from './eventLogger.service'
import { getIsProdEnv } from '../../helpers/getIsProdEnv'
import { LOGGER_WAS_INITIALIZED } from '../../constants'

type TProp = {
  language?: string
}

export const initEventLogger = ({ language }: TProp = {}) => {
  const isProdEnvironment = getIsProdEnv()
  const lang =
    language ?? (localStorage.getItem('gatsby-i18next-language') as string)
  const URLParams = new URLSearchParams(window.location.search)
  const utmTags = Object.fromEntries(URLParams.entries())

  const amplitudeService = new Amplitude({
    apiKey: '26bf9ad22cf44f0afda3593518c68564',
    instanceName: EventLoggerInstanceName.AMPLITUDE,
    isProdEnvironment,
    utmTags,
  })

  const giaService = new Amplitude({
    apiKey: GIA_API_KEYS[lang],
    instanceName: EventLoggerInstanceName.GIA,
    options: getGIAAmplitudeOptions(),
    isProdEnvironment,
    utmTags,
  })

  amplitudeService.configure()
  giaService.configure()

  eventLogger.init(amplitudeService, giaService)

  sessionStorage.setItem(LOGGER_WAS_INITIALIZED, 'true')
}
